import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Courses from "@/components/Courses";
import TestSeries from "@/components/TestSeries";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Faqs from "@/components/Faqs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Courses />
        <TestSeries />
        <Pricing />
        <Testimonials />
        <Faqs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
